/**
 * Town access link URL construction (counterparty / assessor portal).
 * Scope (muni, tax year, court date, recipient emails) is encoded in the magic_token JWT
 * from POST /auth/counterparty-link; this helper only builds the frontend URL wrapper.
 */

import { getBaseURL } from '../../../../utils/config';

const stripTrailingSlashes = (s) => String(s || '').replace(/\/+$/, '');

const frontendBaseFromApiBase = (apiBaseUrl) =>
  stripTrailingSlashes(String(apiBaseUrl || ''))
    .replace(':8081', ':3000')
    .replace('https://server.proprietyrealty.com', 'https://proprietyrealty.com')
    .replace('https://staging.proprietyrealty.com', 'https://demo.proprietyrealty.com');

export const buildTownAccessLink = (magicToken) => {
  const base = frontendBaseFromApiBase(getBaseURL());
  const token = String(magicToken || '').trim();
  if (!base || !token) return '';
  const qs = new URLSearchParams({ magic_token: token });
  return `${base}/analysis?${qs.toString()}`;
};
